/* unplugin-vue-components disabled */import script from "./my-header.vue?vue&type=script&setup=true&lang=ts"
export * from "./my-header.vue?vue&type=script&setup=true&lang=ts"

import "./my-header.vue?vue&type=style&index=0&id=48483ea2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48483ea2"]])

export default __exports__